/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { Collapse, CollapseProps } from "antd";
import { colors } from "./colors";

const collapseWrapperStyle = css`
  display: flex;
  min-width: 100%;
  > .ant-collapse {
    display: flex;
    flex-direction: column;
    gap: 8px;
    min-width: 100%;

    > .ant-collapse-item > .ant-collapse-content > .ant-collapse-content-box {
      padding-top: 0px;
      padding-left: 0px;
      padding-right: 0px;
      padding-bottom: 0px;
    }

    > .ant-collapse-item > .ant-collapse-header {
      padding: 8px;
      border-radius: 8px;
      &:hover {
        background-color: ${colors.whiteHover};
      }

      > .ant-collapse-expand-icon {
        min-height: 24px;
        min-width: 24px;
        align-items: center;
        justify-content: center;
        padding: 0px;
        margin-right: 16px;
        border-radius: 9999px;
        align-self: center;
      }
    }
  }
`;

export const CollapseComponent = ({
  children,
  ghost,
  ...rest
}: CollapseProps) => {
  return (
    <div css={collapseWrapperStyle}>
      <Collapse ghost expandIconPosition="end" {...rest}>
        {children}
      </Collapse>
    </div>
  );
};
